import { render } from "./ExpenseCategoryForm.vue?vue&type=template&id=12c3c5ae&scoped=true"
import script from "./ExpenseCategoryForm.vue?vue&type=script&lang=js"
export * from "./ExpenseCategoryForm.vue?vue&type=script&lang=js"

import "./ExpenseCategoryForm.vue?vue&type=style&index=0&id=12c3c5ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c3c5ae"]])

export default __exports__